import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-white/90 backdrop-blur-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="text-2xl font-light text-gray-900 tracking-tight">Irgiz Export</div>
            <div className="text-sm text-gray-400 hidden sm:block font-light">LLP</div>
          </div>
          
          <nav className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-600 hover:text-emerald-700 transition-colors font-light tracking-wide"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="text-gray-600 hover:text-emerald-700 transition-colors font-light tracking-wide"
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('origin')}
              className="text-gray-600 hover:text-emerald-700 transition-colors font-light tracking-wide"
            >
              Origin
            </button>
            <button
              onClick={() => scrollToSection('logistics')}
              className="text-gray-600 hover:text-emerald-700 transition-colors font-light tracking-wide"
            >
              Logistics
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-emerald-700 text-white px-8 py-2.5 hover:bg-emerald-600 transition-colors font-light tracking-wide"
            >
              Contact
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
